import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { CityData } from "@/utils/cityData";

interface CityFAQProps {
  city: CityData;
}

const CityFAQ = ({ city }: CityFAQProps) => {
  return (
    <section className="py-8 sm:py-12 lg:py-16">
      <div className="container mx-auto px-3 sm:px-4 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center mb-2 sm:mb-3">
            Häufige Fragen zur Cyberversicherung in {city.name}
          </h2>
          <p className="text-sm sm:text-base text-center text-muted-foreground mb-6 sm:mb-8 lg:mb-10">
            Spezifische Antworten für Arztpraxen in {city.name}
          </p>

          <Accordion type="single" collapsible className="w-full space-y-3 sm:space-y-4">
            {city.faqs.slice(0, 6).map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-card/30 backdrop-blur-sm border border-border/50 rounded-lg px-3 sm:px-4 lg:px-6 overflow-hidden hover:border-accent/50 hover:bg-card/50 transition-all"
              >
                <AccordionTrigger className="text-left text-sm sm:text-base font-semibold hover:no-underline py-3 sm:py-4 [&[data-state=open]>svg]:rotate-180">
                  <span className="pr-4">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-muted-foreground leading-relaxed pt-2 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default CityFAQ;
